// extracted by mini-css-extract-plugin
module.exports = {"recommendations":"Recommendations_recommendations__NtLTE"};